// Typelizer digest 969b58a642448b9d50e0da5a1aa46f3c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/bank_connections */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_connections', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/bank_connections */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bank_connections', {}, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/bank_connections/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/bank_connections/:id', params, options),
    method: 'delete',
  }),
}
